import { useLazyQuery } from "@apollo/client/react";
import GET_TEXT_AT_POSITION from "../../queries/invoiceReaderTemplates/getTextAtPosition";
import type { PositionInput } from "../../../models/InvoiceInterpretationInputs";
import type { PositionWithValue } from "../../../models/ClientInvoiceReaderTemplateModel";

type GetTextAtPositionResponse = {
  invoiceInterpretation: {
    getTextAtPosition: PositionWithValue;
  };
};

export const useGetTextAtPosition = () => {
  const [query, { loading, error, data }] = useLazyQuery<GetTextAtPositionResponse>(
    GET_TEXT_AT_POSITION
  );

  const getTextAtPosition = ({
    templateId,
    clientIdentifier,
    pageNumber,
    position,
  }: {
    templateId: string;
    clientIdentifier: string;
    pageNumber: number;
    position: PositionInput;
  }) => {
    return query({
      variables: { templateId, clientIdentifier, pageNumber, position },
    });
  };

  return {
    getTextAtPosition,
    loading,
    error,
    data: data?.invoiceInterpretation?.getTextAtPosition,
  };
};
